import React from 'react';
import styles from './styles.module.css';

interface BBBResourceTimestampProps {
  startTime: number;
  endTime: number;
  isDarkMode: boolean;
}

const BBBResourceTimestamp: React.FC<BBBResourceTimestampProps> = ({
  startTime,
  endTime,
  isDarkMode,
}) => {
  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const timestampClass = `${styles.timestamp} ${!isDarkMode && styles.timestampDarkMode}`;

  return (
    <div className={timestampClass}>
      <span className={styles.timestampDot}>•</span>
      <span className={styles.timestampText}>
        {formatTime(startTime)} - {formatTime(endTime)}
      </span>
    </div>
  );
};

export default BBBResourceTimestamp;
